export const initialState = {
    title:'',
    description:'',
    price:0,
    category:'',
    quantity:0,
    tags:[]
}
export const ACTION_TYPES = {
    CHANGE_INPUT:"change-input",
    ADD_TAG:"add-tag",
    REMOVE_TAG:'remove-tag',
    INCREASE:'increase',
    DECREASE:'decrease',

};
export const formReducer = (state  , action)=> {
    switch (action.type) {
        case ACTION_TYPES.CHANGE_INPUT:{
            console.log(state)
            return {...state,[action.data.name]: action.data.value}

        }
        case ACTION_TYPES.ADD_TAG:{
             
            return {...state,tags: action.data.split(',').filter(Boolean)}
        }

        case ACTION_TYPES.REMOVE_TAG:
        {

            console.log('AAAAA')
           /* state.tags.splice(action.data,1)
            console.log(state.tags)*/
         let tagr=state.tags.filter((t,index)=>{
                return t !==action.data.tag && index !== action.data.index
            })

            return {...state,tags: tagr }
        }

        case ACTION_TYPES.INCREASE:
            return {...state,quantity:state.quantity+1}
        case ACTION_TYPES.DECREASE:
            return {...state,quantity:state.quantity > 0 ? state.quantity-1 : state.quantity}
        default:
            return state
    }
}